import { FadersHorizontalIcon, ListPlusIcon } from '@phosphor-icons/react'

import { AccessProfileIcon } from '@assets/svgs/AccessProfileIcon'
import { ConsumptionIcon } from '@assets/svgs/ConsumptionIcon'
import { DashboardIcon } from '@assets/svgs/DashboardIcon'
import { DepreciationIcon } from '@assets/svgs/DepreciationIcon'
import { FinancialManagementIcon } from '@assets/svgs/FinancialManagementIcon'
import { InvoicingIcon } from '@assets/svgs/InvoicingIcon'
import { OtherExpensesIcon } from '@assets/svgs/OtherExpensesIcon'
import { PackageIcon } from '@assets/svgs/PackageIcon'
import { PeopleIcon } from '@assets/svgs/PeopleIcon'
import { PreviewIcon } from '@assets/svgs/PreviewIcon'
import { SettingsIcon } from '@assets/svgs/SettingsIcon'
import { UsersIcon } from '@assets/svgs/UsersIcon'

export const getSideBarIcon = (icon: string) => {
  const icons = {
    dashboard: <DashboardIcon />,
    'financial-management': <FinancialManagementIcon />,
    preview: <PreviewIcon />,
    invoicing: <InvoicingIcon />,
    'list-plus': <ListPlusIcon weight="bold" />,
    consumption: <ConsumptionIcon />,
    'other-expenses': <OtherExpensesIcon />,
    depreciation: <DepreciationIcon />,
    people: <PeopleIcon />,
    settings: <SettingsIcon />,
    users: <UsersIcon />,
    'access-profile': <AccessProfileIcon />,
    package: <PackageIcon />,
    'faders-horizontal': <FadersHorizontalIcon/>
  }

  return icons[icon as keyof typeof icons]
}
